import React, { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [language, setLanguage] = useState('sindhi'); // Default to Sindhi

  // Load saved language preference from localStorage
  useEffect(() => {
    const savedLang = localStorage.getItem('sas_language');
    if (savedLang && ['sindhi', 'english'].includes(savedLang)) {
      setLanguage(savedLang);
      document.documentElement.lang = savedLang === 'sindhi' ? 'sd' : 'en';
      document.documentElement.dir = savedLang === 'sindhi' ? 'rtl' : 'ltr';
    } else {
      // Default to Sindhi if no saved preference
      localStorage.setItem('sas_language', 'sindhi');
      document.documentElement.lang = 'sd';
      document.documentElement.dir = 'rtl';
    }
  }, []);

  const toggleLanguage = (lang) => {
    if (['sindhi', 'english'].includes(lang)) {
      setLanguage(lang);
      localStorage.setItem('sas_language', lang);
      document.documentElement.lang = lang === 'sindhi' ? 'sd' : 'en';
      document.documentElement.dir = lang === 'sindhi' ? 'rtl' : 'ltr';
    }
  };

  return (
    <LanguageContext.Provider value={{ language, toggleLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
}

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within LanguageProvider');
  }
  return context;
};
